

<div *ngIf="session as s" class="flex column-gap-3 flex-wrap">
  <span *ngIf="s.startAt" class="inline-flex gap-2 align-items-center">
    <i class="pi pi-calendar"></i>

    <span class="details-block-wrap">
      <span class="detail-block">
        <span class="capitalize">
          {{ s.startAt | localizedDate:'EEEEEE':undefined:'UTC+0' }} 
        </span>
        <span>&nbsp;</span>
        <span>
          {{ s.startAt | localizedDate:'H:mm':undefined:'UTC+0'}} - {{ s.endAt | localizedDate:'H:mm':undefined:'UTC+0'}}
        </span>
      </span>
      
      <span *ngIf="showDate" class="detail-block">
        {{ s.startAt | localizedDate:'d.L.':undefined:'UTC+0' }}
      </span>

      <span class="detail-block">
        {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.session-index' | translate:{ index: s.index + 1 } }}
      </span>
    </span>
  </span>

  <span *ngIf="(s.location | locationName:{ useInternalTitle: true, isOnline: s.format===SessionFormat.ONLINE }) as locTitle" class="inline-flex gap-2 align-items-center">
    <i class="pi pi-map-marker"></i>

    {{ locTitle }}
  </span>
</div>
